import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { startWith, map } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AlertComponent } from '../alert/alert.component';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import { ConfirmSaveComponent } from '../confirm-save/confirm-save.component';
import { DataService } from '../data.service';
import { DeleteComponent } from '../delete/delete.component';
import { FinalpopupComponent } from '../finalpopup/finalpopup.component';
import { HttpService } from '../http.service';
import { SavedialogComponent } from '../savedialog/savedialog.component';
import { MainpageComponent } from '../mainpage/mainpage.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToggleService } from '../toggle.service';
import { EditdialogComponent } from '../editdialog/editdialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';

@Component({
  selector: 'app-create-edit-page',
  templateUrl: './create-edit-page.component.html',
  styleUrls: ['./create-edit-page.component.scss']
})
export class CreateEditPageComponent implements OnInit {
   color: String = "gray"
  color2: String = "gray"
  display: String = "flex"
  bgcolor: String = "#E8F2FB"
  bgcolor2: String = "white"
  headdisplay: String = "flex"
  popupdisplay: any="65%"
  secondpagelist: any;
  year: any;
  batch: any;
  orientation: any;
  organisation: any;
  coachingType: any;
  programName: any;
  promotionCourseTrack: any;
  yearControl = new FormControl();
  batchControl = new FormControl();
  orientationControl = new FormControl();
  organisationControl = new FormControl();
  CoachingControl = new FormControl();
  ProgramNameControl = new FormControl();
  PromotingCoursetrackControl = new FormControl();
  yearOptions: any;
  years: any;
  batchOptions: any;
  batchName: any;
  orientationName: any;
  organizationName: any;
  coachingtype: any;
  programname: any;
  promotingcourseTrackId: any;
  orientationOptions: any;
  organisationOptions: any;
  coachingTypeOptions: any;
  programNameOptions: any;
  promotingcoursetrackOptions: any;
  selectImage: any = "../../../../../assets/image/selected.svg";
  selectImage2: any = "../../../../../assets/image/unselected.svg";
  headdisplay2: any = 'none';
  priorityOrderList: any;
  priorityName: any;
  paymentModels: any;
  receiptTypes: any;
  priorityOrderListControl = new FormControl();
  paymentModelsControl = new FormControl();
  receiptTypesControl = new FormControl();
  priorityNameOptions: any;
  receiptTypesOptions: any;
  paymentModelsOptions: any;
  receiptName: any;
  paymentName: any;
  transactionHead: any;
  transhead: any;
  transheadFee: any;
  transheadAkash: any;
  askashHead: any;
  feeHead: any;
  feeHeadOptions: any;
  feeControl = new FormControl();
  akashControl = new FormControl();
  akashHeadOptions: any;
  head: any;
  headOptions: any;
  headControl: any = new FormControl();
  stateGstRate: any = '0.00';
  centralGstRate: any = '0.00';
  totalGstRate: any = '0.00';
  orgId: any;
  transheadId: any;
  gst: any;
  listArray: any[]=[];
  headType: any;
  orgsub: any;
  taxvalue: string='NoTax';
  model: any;
  receipt: any;
  amount: number = 0;
  lists: any[] = [];
  headDisplayList: any = 'none';
  submitbuttondiv: any = 'none';
  amountsum: number = 0;
  headtypename: any = 'Course Fee ';
  listtype: any[] = [];
  akashlist: any[] = [];
  data: any;
  senddata: any[] = [];
  myGroup: any;
  subhead: any;
  initaldta: any;
  academicId: any;
  batchId: any;
  programId: any;
  orientationtype: any;
  coachintype: any;
  incentive: any;
  register: any;
  orgcon: any;
  coursestr: any;
  paycon: any;
  transheadcode: any;
  appprorityId: any = 0;
  paymentpriority: any = 0;
  conscessionpriority: any = 0;
  deductionpriority: any = 0;
  paymentcal: String = 'FLAT';
  concessionmod: String = 'FLAT';
  deductionmod: String = 'FLAT';
  reiciettype: String = 'BY_PRE_PRINTED_RECEIPT';
  taxOnNetFee: any = 0;
  taxInPaid: any = 0;
  previousfee: any;
  saveheaddata: any[] = [];
  payload: any;
  object: any;
  change: any=false;
  i: any=0;
  initaldatacolor: any;
  ydatabase: any = 'red';
  btndisplay: any = 'flex';
  btndisplay2: any = 'flex';
  courseTrackName: any;
  campusName: any;
  coachingcolor: any = '#666666';
  coachingcolor2: any = '#666666';
  verificationlist: any[] = [];
  verificationsubheadlist: any[] = [];
  verifyheadlist: any[] = [];
  akashcolor: any = '#6666666';
  akashcolor2: any = '#CAD2DE';
  coursefeeID: any = 0;
  details: any;
  whethereditOrnot: any = false;
  finalacademyyear: any;
  finalbatch: any;
  finalorient: String = '';
  finalorg: any;
  finalcoachingtype: any;
  finalprogram: any;
  className: any;
  retrievedObject: any;
  appSales = new FormControl()
  priority = new FormControl()
  conPriority = new FormControl()
  deductPriority = new FormControl()
  headCalculationType = new FormControl()
  deductCalculationType = new FormControl()
  conHeadCalculationType = new FormControl()
  receiptsType = new FormControl()
  appfeeedit: any;
  additional: any;
  excess: any;
  paypriorityname: any='Zero Priority';
  conName: any='Zero Priority';
  dedpriority: any='Zero Priority';
  appsalesName: any='Zero Priority';
  classnametext: any;
  maincontainerborder: any;
  maincontainerborder1: string='none';
  headcontainerborder: any=" 0.5px solid #CCCCCC";
  Akashheadcontainerborder: string=" 0.5px solid #CCCCCC";
  hrdispaly:string='none'
  isdisabled:boolean=false;
  isdisabled2:boolean=false;
  orglist: any;
  organisationcontrol=new FormControl()
  organisationcontrol2=new FormControl()
  organisationOptions2: any;
  length:any;
  totalsum: any;
  amountsum2: any;
  priorityNameOptions1: any;
  priorityNameOptions2: any;
  priorityNameOptions3: any;
  priorityNameOptions4: any;
  paymentModelsOptions2: any;
  paymentModelsOptions3: any;
  j: any;
  courseFeesubhead: any[]=[];
  payloadcoursefeelist: any[]=[];
  previoustotalcoursefee: any;
  previousakashAmount: any;
  paymentdisplay: String = 'FLAT';
  condisplay:  String = 'FLAT';
  deductdisplay:  String = 'FLAT';
  recietdisplay:  String = 'BY_PRE_PRINTED_RECEIPT';
  akashcontainerborder: string='none';
  payloadakashbooks: any[]=[];
  coursefeeheadid: any=0;
  finalHeadAmount: any;
  finalDiaplayName: any;
  finalCourseDisplay: any;
  verificationDialog: any;
  width: any;
  height: any;
  top: any;
  right: any;
  status: any=true;
  addedlist: any[]=[];
  finalpromtingCourseTrack: any;
  dialogdata:any;
  dialogHeadCode: any;
  code: any="FEE";
  constructor(private app:MainpageComponent,private dtservice: DataService,private spinner: NgxSpinnerService, private http: HttpService, private dialog: NgDialogAnimationService,private dialog1:MatDialog, private router: Router,private fromBuilder:FormBuilder) { }
  ngOnInit(): void {
    this.getorglist()
this.details=[]
    this.getapidata()
    
    this.checklist()
    this.campusName = this.dtservice.getcampusName();
    this.courseTrackName = this.dtservice.getcoursetrackName()
    this.className = this.dtservice.getclassName();
    this.initaldta = new FormGroup(
      {
        year: new FormControl(),
        batch: new FormControl(),
        orientation: new FormControl(),
        organisation: new FormControl(),
        CoachingControl: new FormControl(),
        programname: new FormControl(),
        promotingcoursetrack: new FormControl()
      }
    )
    // this.dialogposition()
    this.length=this.lists.length+this.akashlist.length;
    this.data = this.fromBuilder.group({
      totalCourseFee: ["",Validators.required],
      maxConcession: ['',Validators.required],
      orgConcession: ['',Validators.required],
      currentStrength: ['',Validators.required],
      registrationFee: ['',Validators.required],
      proincentive: ['No',Validators.required],
      organisationcontrol:["",Validators.required]
    });
   
    this.initaldta =this.fromBuilder.group(
      {
        year:["",Validators.required],
        batch:["",Validators.required],
        orientation:["",Validators.required],
        organisation:["",Validators.required],
        CoachingControl:["",Validators.required],
        programname: ["",Validators.required],
        promotingcoursetrack:["",Validators.required],
      }
    )
    this.myGroup = this.fromBuilder.group({
      akashdata: new FormControl('',Validators.required)
    });
    
    this.verificationlist = [
      {
        'name': 'Year',
        'check': this.finalacademyyear,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Batch',
        'check': this.finalbatch,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Orientation',
        'check': this.finalorient,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Organisation',
        'check': this.finalorg,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Coaching Type',
        'check': this.finalcoachingtype,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Program Name',
        'check': this.finalprogram,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Promoting Course Track',
        'check': this.finalacademyyear,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },

    ]
    this.verifyheadlist = [
      {
        'name': 'Total Course Fee',
        'check': this.data.get('totalCourseFee').value,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Max Concession',
        'check': this.data.get('maxConcession').value,
        'Color': '666666',
        'Color2': '#CAD2DE'

      },
      {
        'name': 'Org Concession',
        'check': this.data.get('orgConcession').value,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Current Strength',
        'check': this.data.get('currentStrength').value,
        'Color': '666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Registration Fee',
        'check': this.data.get('registrationFee').value,
        'Color': '666666',
        'Color2': '#CAD2DE'
      }
    ]
    this.checkbuttonlist()
  }
  checklist()
  {
    if(this.lists.length!=0)
    {
      this.hrdispaly='flex'
      this.listtype=this.lists
      this.maincontainerborder1='1px solid #cad2de'
      this.headcontainerborder='none'
      this.getSum()
      this.btndisplay = 'none'
      this.head = this.transheadFee
      this.headDisplayList = 'flex'
    }
    else{
      this.btndisplay = 'flex'
      this.headDisplayList = 'none'
      this.headcontainerborder=" 0.5px solid #CCCCCC"
      this.maincontainerborder1='none'
      this.hrdispaly='none'
    }
    this.checkbuttonlist()
  }
  checkbuttonlist()
  {
   
    if(this.listtype.length==0)
    {
      this.submitbuttondiv = 'none'
    }
    else{
      this.submitbuttondiv = 'flex'
    }
  }
  getpriorityname(value:any,i:any,name:any)
  {
    if(value==0)
    {
      this.listtype[i][name]= "Zero Priority"
    }
    else if(value==1)
    {
      this.listtype[i][name]= "1st Priority"
    }
    else if(value==2)
    {
      this.listtype[i][name]= "2nd Priority"
    }
    else if(value==3)
    {
      this.listtype[i][name]= "3rd Priority"
    }
    else if(value==4)
    {
      this.listtype[i][name]= "4th Priority"
    }
    else if(value==5)
    {
      this.listtype[i][name]= "5th Priority"
    }
  }
  checklist2()
  {
     if(this.akashlist.length!=0)
    {
      this.listtype=this.akashlist
      this.hrdispaly='flex'
      this.getSum()
      this.btndisplay2 = 'none'
      this.head = this.transheadAkash
      this.Akashheadcontainerborder='none'
      this.maincontainerborder1='1px solid #cad2de'
      this.headDisplayList = 'flex'
      this.submitbuttondiv = 'flex'
    }
    else{
      this.btndisplay2 = 'flex'
      this.headDisplayList = 'none'
      this.Akashheadcontainerborder=" 0.5px solid #CCCCCC"
      this.hrdispaly='none'
      this.maincontainerborder1='none'
    }
    this.checkbuttonlist()
  }
  getorglist()
  {
    this.spinner.show()
     this.http.getorglist().subscribe((res: any) => {
    
      this.orglist=res
      this.spinner.hide()
      this.organisation = this.orglist;
      this.organisationOptions = this.initaldta.get('organisation').valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.organisation, 'orgName' || ''))
      )
      this.organisationOptions2 = this.organisationcontrol.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.organisation, 'orgName' || ''))
      )
    });
  }
  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));

    return filteredList;
  }
  getdetails() {
    this.coursefeeID = this.dtservice.courseFeeID; 
this.spinner.show()
    this.http.getdetails(this.coursefeeID).subscribe((res: any) => {
      this.details = res.campusCourseFeeApproval[0];
      this.listArray = res.courseFeeHead
      this.spinner.hide()
       this.previoustotalcoursefee=0;
       this.previousakashAmount=0;
      this.lists=[]
      this.akashlist=[]
      for(let i=0;i<this.listArray.length;i++)
      {
        this.addedlist.push(this.listArray[i].courseFeeHeadList.tranHeadId)
        if(this.listArray[i].headCode=='FEE')
        {
          this.tax(this.listArray[i].courseFeeHeadList.taxType)
          this.lists.push(this.listArray[i].courseFeeHeadList)
          
          const item=  {
            "courseFeeHeadId":this.listArray[i].courseFeeHeadList.courseFeeHeadId,
            "headAmount": this.listArray[i].courseFeeHeadList.headAmount,
             "tranHeadId": this.listArray[i].courseFeeHeadList.tranHeadId,
            "subTransCode": this.listArray[i].courseFeeHeadList.subTransCode,
            "appFee":this.listArray[i].courseFeeHeadList.appFee,
            "allowAdditionalAmount":this.listArray[i].courseFeeHeadList.allowAdditionalAmount,
            "allowExcessAmount":this.listArray[i].courseFeeHeadList.allowExcessAmount,
            "taxInPaid":this.taxInPaid,
            "taxOnNetFee":this.taxOnNetFee ,
            "appSales":this.listArray[i].courseFeeHeadList.appSales,
            "conPayments":this.listArray[i].courseFeeHeadList.conPayments,
            "conPriority":this.listArray[i].courseFeeHeadList.conPriority,
            "deductPriority":this.listArray[i].courseFeeHeadList.deductPriority,
            "paymentModel":this.listArray[i].courseFeeHeadList.paymentModel,
            "deductionModel": this.listArray[i].courseFeeHeadList.deductionModel,
            "concessionModel":this.listArray[i].courseFeeHeadList.concessionModel,
            "displayName": this.listArray[i].courseFeeHeadList.displayName,
            "courseDisplay":this.listArray[i].courseFeeHeadList.courseDisplay,
            "receiptsType":this.listArray[i].courseFeeHeadList.receiptsType,
            "status":true
          }
   
          this.payloadcoursefeelist.push(item)
          this.previoustotalcoursefee=this.previoustotalcoursefee+this.listArray[i].courseFeeHeadList.headAmount
        }
        else if(this.listArray[i].headCode=='AKASH_BOOKS')
        {
          const item=  {
            "courseFeeHeadId":this.listArray[i].courseFeeHeadList.courseFeeHeadId,
            "headAmount": this.listArray[i].courseFeeHeadList.headAmount,
             "tranHeadId": this.listArray[i].courseFeeHeadList.tranHeadId,
            "subTransCode": this.listArray[i].courseFeeHeadList.subTransCode,
            "appFee":this.listArray[i].courseFeeHeadList.appFee,
            "allowAdditionalAmount":this.listArray[i].courseFeeHeadList.allowAdditionalAmount,
            "allowExcessAmount":this.listArray[i].courseFeeHeadList.allowExcessAmount,
            "taxInPaid":this.taxInPaid,
            "taxOnNetFee":this.taxOnNetFee ,
            "appSales":this.listArray[i].courseFeeHeadList.appSales,
            "conPayments":this.listArray[i].courseFeeHeadList.conPayments,
            "conPriority":this.listArray[i].courseFeeHeadList.conPriority,
            "deductPriority":this.listArray[i].courseFeeHeadList.deductPriority,
            "paymentModel":this.listArray[i].courseFeeHeadList.paymentModel,
            "deductionModel": this.listArray[i].courseFeeHeadList.deductionModel,
            "concessionModel":this.listArray[i].courseFeeHeadList.concessionModel,
            "displayName": this.listArray[i].courseFeeHeadList.displayName,
            "courseDisplay":this.listArray[i].courseFeeHeadList.courseDisplay,
            "receiptsType":this.listArray[i].courseFeeHeadList.receiptsType,
            "status":true
          }
          this.payloadakashbooks.push(item)
          this.akashlist.push(this.listArray[i].courseFeeHeadList)
          this.previousakashAmount=this.previousakashAmount+this.listArray[i].courseFeeHeadList.headAmount
        }
      }        
              this.data.patchValue({
                totalCourseFee: this.previoustotalcoursefee,
                maxConcession:this.details.maxConcession,
                orgConcession:this.details.orgConcession,
                currentStrength:this.details.courseStrength,
                registrationFee:this.details.registrationFee
              });
              this.myGroup.patchValue({
                akashdata:this.previousakashAmount
                })
     
      this.orgsub=this.listArray[0].courseFeeHeadList.orgShortName
      this.orgId=this.listArray[0].courseFeeHeadList.orgId
      this.taxvalue="NoTax"
      this.checklist()
    });

  }

  gotosubheadpopup(i: any, change: any,value:any) {
   console.log(value)
    this.change = change;
    this.i = i;
    if(value.headCode=='FEE')
    {
      this.head = this.transheadFee
      
    }
    else if(value.headCode=='AKASH_BOOKS')
     {
      this.head = this.transheadAkash
      
    }
    this.getdialogData(this.change,this.i,value.headCode)
  
    
  
  
  }
  deleteitem(i: any,value:any) {
   
    if(value=="FEE")
      {
        const deleteDialogRef = this.dialog.open(DeleteComponent, {
          id: 'delete'
        }); 
        
        deleteDialogRef.afterClosed().subscribe(deleteResult => {
          
          if (deleteResult) {
            this.status=false;
            this.payloadcoursefeelist[i].status=false
            this.listtype.splice(i, 1);
            const index= this.addedlist.indexOf(value)
            this.addedlist.splice(index,1)
            deleteDialogRef.close();
            this.dialog.open(ConfirmDeleteComponent,{
              id:"ok",
            })
          }
        });
       
      }
      else{
        const deleteDialogRef = this.dialog.open(DeleteComponent, {
          id: 'delete'
        });
        
        deleteDialogRef.afterClosed().subscribe(deleteResult => {
          
          if (deleteResult) {
            this.status=false;
            this.payloadakashbooks[i].status=false
            this.listtype.splice(i, 1);
            const index= this.addedlist.indexOf(value)
            this.addedlist.splice(index,1)
            deleteDialogRef.close();
    
            this.dialog.open(ConfirmDeleteComponent,{
              id:"ok",
            })
          }
        });
      }

  }
  tax(value: any) {
    this.taxvalue = value;
    if (value == 'taxInclusive') {
      this.spinner.show()
      this.http.getTax(this.dtservice.campusId, this.orgId, this.transheadId).subscribe((res: any) => {
        this.stateGstRate = res.stateGstRate;
        this.centralGstRate = res.centralGstRate;
        this.totalGstRate = res.totalGstRate;
        this.spinner.hide()
      });
      this.taxOnNetFee = 1
      this.taxInPaid = 0
    }
    else if (value == 'taxExclusive') {
      this.spinner.show()
      this.http.getTax(this.dtservice.campusId, this.orgId, this.transheadId).subscribe((res: any) => {
        this.stateGstRate = res.stateGstRate;
        this.centralGstRate = res.centralGstRate;
        this.totalGstRate = res.totalGstRate;
        this.spinner.hide()
      });
      this.taxOnNetFee = 0
      this.taxInPaid = 1
    }
    else {
      this.taxOnNetFee = 0
      this.taxInPaid = 0
    }
  }
  clearcoursefee(value:any) {
const deleteDialogRef = this.dialog.open(DeleteComponent, {
  id: 'delete'
});

deleteDialogRef.afterClosed().subscribe(deleteResult => {
  
  if (deleteResult&& value=="FEE") {
   
    this.data.reset();
    this.dialog1.getDialogById('ok')?.close()
    deleteDialogRef.close();
    this.dialog.open(ConfirmDeleteComponent,{
      id:"ok",
    })
  }
  else if(deleteResult&& value=="AKASH")
  {
    this.myGroup.reset();
    this.dialog1.getDialogById('ok')?.close()
    deleteDialogRef.close();
    this.dialog.open(ConfirmDeleteComponent,{
      id:"ok",
    })
  }
});


}

  openDialog() {
    this.getAmount();
    const senddata = [this.data, this.lists, this.akashlist, this.myGroup, this.payload]
    const data = this.dialog.open(FinalpopupComponent, {
      width: '500px',
      maxHeight:'700px',
      data: { senddata }
    });
    data.afterClosed().subscribe(res=>{
      if(res)
        {
          this.app.toggleComponents()
        }
        this.saveheaddata=[]
    })

  }
  getapidata() {
    this.spinner.show()
    this.http.getsecondpagelist(this.dtservice.campusId,this.dtservice.classId,this.dtservice.streamId,this.dtservice.campusTrackId).subscribe(res => {
      this.secondpagelist = res;
      this.spinner.hide()
      if (!this.whethereditOrnot) {
        this.year = this.secondpagelist.academicYear;
        this.batch = this.secondpagelist.batchName;
        this.orientation = this.secondpagelist.orientation
        this.coachingType = this.secondpagelist.coachingType;
        this.programName = this.secondpagelist.programName;
        this.promotionCourseTrack = this.secondpagelist.promotingCourseTrackId;
        this.yearOptions = this.initaldta.get('year').valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.year, 'academicYear'))
        );
        this.batchOptions = this.initaldta.get('batch').valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.batch, 'batchName' || ''))
        )
        this.orientationOptions = this.initaldta.get('orientation').valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.orientation, 'orientation' || ''))
        )
        this.coachingTypeOptions = this.initaldta.get('CoachingControl').valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.coachingType, 'coachngType' || ''))
        )
        this.programNameOptions = this.initaldta.get('programname').valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.programName, 'programName' || ''))
        )
        this.promotingcoursetrackOptions = this.initaldta.get('promotingcoursetrack').valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.promotionCourseTrack, 'promotingCourseTrackId' || ''))
        )
      }
      this.priorityOrderList = this.secondpagelist.priorityOrderList;
      this.paymentModels = this.secondpagelist.paymentModels;
      this.receiptTypes = this.secondpagelist.receiptTypes;
      this.transactionHead = this.secondpagelist.transactionHeadsList;
      this.transheadFee = this.transactionHead[0].transactionHeads;
      this.transheadAkash = this.transactionHead[1].transactionHeads;
      this.priorityNameOptions1 = this.appSales.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
      )
      this.priorityNameOptions2 = this.conPriority.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
      )
      this.priorityNameOptions3 = this.deductPriority.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
      )
      this.priorityNameOptions4 = this.priority.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.priorityOrderList, 'priorityName' || ''))
      )

      this.receiptTypesOptions = this.receiptsType.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.receiptTypes, 'displayName' || ''))
      )
      this.paymentModelsOptions = this.headCalculationType.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.paymentModels, 'displayName' || ''))
      )
      this.paymentModelsOptions2 = this.conHeadCalculationType.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.paymentModels, 'displayName' || ''))
      )
      this.paymentModelsOptions3 = this.deductCalculationType.valueChanges.pipe(
        startWith(''),
        map((value: string) => this.Filter(value, this.paymentModels, 'displayName' || ''))
      )
    
    })
    if (this.dtservice.editornot) {
      this.getdetails()
      this.whethereditOrnot = true;
      this.dtservice.editornot = false;
    }
   
  }

  changecolor() {

    this.bgcolor = " #E8F2FB";
    this.selectImage = "../../../../../assets/image/selected.svg";
    this.selectImage2 = "../../../../../assets/image/unselected.svg";
    this.bgcolor2 = "white";
    this.headtypename = 'Course Fee '


  }
  changecolor2() {

    this.bgcolor2 = " #E8F2FB";
    this.bgcolor = "white";
    this.selectImage2 = "../../../../../assets/image/selected.svg";
    this.selectImage = "../../../../../assets/image/unselected.svg";
    this.headtypename = 'Akash Books'

  }
  visibleoptions() {
    this.display = 'flex';
  }
  visibleContainer() {
    this.listtype=this.lists
    this.code="FEE"
    this.headdisplay = 'flex';
    this.headdisplay2 = 'none';
    this.checklist()
    this.dialogHeadCode="FEE"
    this.change=false;
  }
  visibleContainer2() {
    this.listtype=this.akashlist
     this.code="AKASH_BOOKS"
    this.dialogHeadCode="AKASH_BOOKS"
    this.hrdispaly='none'
    this.headdisplay2 = 'flex';
    this.headdisplay = 'none';
    this.akashcontainerborder='1px solid #cad2De'
    this.checklist2()
    this.change=false;
  }
  popvisible(value: any) {
   
    this.verification(value);
  }
 
  headcode(value: any) {
    this.transheadId = value.transHeadId;
    this.transheadcode = value.headName;
    this.addedlist.push(this.transheadId)
  
  }
  getboolean(value: any) {
    if (value == 'option1') {
      return 1
    }
    else {
      return 0;
    }
  }
  getorgId(value: any) {
    this.orgId = value.orgId;
    this.orgsub = value.orgShortName
    // this.orgcolor = '#333333'

  }
  getacademicId(value: any) {
    this.academicId = value.academicId;
    // this.yearcolor = '#333333'

  }
  getbatchId(value: any) {
    this.batchId = value.batchId;
    // this.btachcolor = '#333333'

  }
  getprogramId(value: any) {
    this.programId = value.programId;
    // this.programcolor = '#333333'

  }
  getorientationtype(value: any) {
    this.orientationtype = value.orientation;
    // this.orientcolor = '#333333'
  }
  getcoachingType(value: any) {
    this.coachintype = value.coachngType
    // this.coachingcolor='#333333'
  }
  getpromtingCourseTrack(value:any)
  {
    this.finalpromtingCourseTrack=value;
  }
  verification(value: any) {
    this.geteditdata()
    this.verificationlist = [
      {
        'name': 'Year',
        'check': this.finalacademyyear,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Batch',
        'check': this.finalbatch,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Orientation',
        'check': this.finalorient,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Organisation',
        'check': this.finalorg,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Coaching Type',
        'check': this.finalcoachingtype,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Program Name',
        'check': this.finalprogram,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Promoting Course Track',
        'check': this.finalpromtingCourseTrack,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
    ]
    let datacheck = false;
    for (let i = 0; i < this.verificationlist.length; i++) {
      datacheck = this.verify(this.verificationlist[i].check)
      if (!datacheck) {
        this.verificationlist[i].Color = 'red';
        this.verificationlist[i].Color2 = 'red  !important';
        const data ="Please Select "+ this.verificationlist[i].name
        this.dialog.open(AlertComponent, {
          width: '800px',
          position: { top: '10px', right:'10px' },
          data: { data }
        });
        break;
      }
    }
    if (datacheck) {
      if (value == 'FEE') {
        this.verifyhead(value)
        this.head = this.transheadFee
      
      }
      else if (value == 'AKASH') {
        this.verifyheadtwo(value)
        this.head = this.transheadAkash
       
      }
    }
   
  }
  verifyhead( headValue:any) {
    this.verifyheadlist = [
      {
        'name': 'Total Course Fee',
        'check': this.data.get('totalCourseFee').value,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Max Concession',
        'check': this.data.get('maxConcession').value,
        'Color': '#666666',
        'Color2': '#CAD2DE'

      },
      {
        'name': 'Org Concession',
        'check': this.data.get('orgConcession').value,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Current Strength',
        'check': this.data.get('currentStrength').value,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      },
      {
        'name': 'Registration Fee',
        'check': this.data.get('registrationFee').value,
        'Color': '#666666',
        'Color2': '#CAD2DE'
      }
    ]
    let datacheck = false;
    for (let i = 0; i < this.verifyheadlist.length; i++) {
      datacheck = this.verify(this.verifyheadlist[i].check)
      if (!datacheck) {
        //  window.alert('Please Select '+this.verificationlist[i].name)
        this.verifyheadlist[i].Color = 'red';
        this.verifyheadlist[i].Color2 = 'red  !important';
        const data ="Please Enter "+  this.verifyheadlist[i].name
        this.dialog.open(AlertComponent, {
          width: '800px',
          position: { top: '10px', right: '10px' },
          data: { data }
        });
        break;
      }
    }
    if (datacheck) {
       this.getdialogData(this.change,0,headValue)
      this.headtypename = 'Course Fee '

    }
  }
  verifyheadtwo(headValue:any) {
    
    if (this.myGroup.get('akashdata').value == null) {
      this.akashcolor = 'red'
      this.akashcolor2 = 'red !important';
    }
    else {
      this.getdialogData(this.change,0,headValue)
      this.headtypename = 'AKASH '
    }
  }
  courseFeeDialog(value:any)
  {
 
    const data ={
      "secondpagelist":this.secondpagelist,
      "orglist":this.orglist,
      "orgId":this.orgId,
      "addedList":this.addedlist,
      "headDisplayList":this.transheadFee,
      "data":this.dialogdata
   }

   const dialogref= this.dialog.open(EditdialogComponent, {
     width: "960px",
     height: "1000px",
     panelClass: [ 'animate__animated', 'animate__slideInRight'],
     position: { right: '0' },
     maxWidth: '100%',
     animation: { to: 'left' },
     autoFocus:false,
     disableClose :true,
     hasBackdrop:false,
     data:data,
     
     
   });
   dialogref.afterClosed().subscribe((res:any)=>{
    if(res.newdata)
      {
     if(this.change)
      {
        this.payloadcoursefeelist.splice(this.i,1,res.newdata)
        this.lists.splice(this.i,1,res.listdata)
      }
      else {
        this.payloadcoursefeelist.push(res.newdata)
        this.lists.push(res.listdata)
      }
      this.dialogHeadCode="FEE"
         this.headDisplayList = 'flex';
         this.headcontainerborder='none'
         this.hrdispaly='flex'
         this.maincontainerborder1='1px solid #cad2de'
         this.submitbuttondiv = 'flex';
         this.isdisabled=true
         this.btndisplay = 'none'
         this.getSum()
         this.listtype=this.lists
    }
      
       this.change = false;
    
   })
  }
  akashDialog(value:any)
  {
  
    const data ={
      "secondpagelist":this.secondpagelist,
      "orglist":this.orglist,
      "orgId":this.orgId,
      "addedList":this.addedlist,
      "headDisplayList":this.transheadAkash,
      "data":this.dialogdata
   }
   const dialogref= this.dialog.open(EditdialogComponent, {
     width: "960px",
     height: "1000px",
     panelClass: [ 'animate__animated', 'animate__slideInRight'],
     position: { right: '0' },
     maxWidth: '100%',
     animation: { to: 'left' },
     autoFocus:false,
     disableClose :true,
     hasBackdrop:false,
     data:data
     
   });
   dialogref.afterClosed().subscribe((res1:any)=>{
  if(res1.newdata)
    {
      if(this.change)
        {
          this.payloadakashbooks.splice(this.i,1,res1.newdata)
          this.akashlist.splice(this.i,1,res1.listdata)
        }
        else {
          this.payloadakashbooks.push(res1.newdata)
          this.akashlist.push(res1.listdata)
        }
        this.dialogHeadCode="AKASH_BOOKS"
        this.headDisplayList = 'flex';
        this.headcontainerborder='none'
        this.hrdispaly='flex'
        this.maincontainerborder1='1px solid #cad2de'
        this.submitbuttondiv = 'flex';
        this.isdisabled=true
        this.btndisplay = 'none'
        this.getSum()
        this.listtype=this.akashlist
    }
    
        this.change = false;

       
  })
  }
  getdialogData(change:any,i:any,value:any)
  {
    this.addedlist=[]
      if(change)
        {
          if(value=="FEE")
            {
             for(let k=0;k<this.payloadcoursefeelist.length;k++)
              {
                if(this.payloadcoursefeelist[k].status)
                  {
                this.addedlist.push(this.payloadcoursefeelist[k].tranHeadId)
                  }
              }
              this.dialogdata = {
                "orgId":this.orgId,
                "orgSub":this.orgsub,
                "courseFeeHeadId": this.payloadcoursefeelist[i].courseFeeHeadId,
                "headCode":"FEE",
                "headAmount": this.payloadcoursefeelist[i].headAmount,
                "tranHeadId": this.payloadcoursefeelist[i].tranHeadId,
                "subTransCode": this.payloadcoursefeelist[i].subTransCode,
                "appFee": this.payloadcoursefeelist[i].appFee,
                "allowAdditionalAmount": this.payloadcoursefeelist[i].allowAdditionalAmount,
                "allowExcessAmount": this.payloadcoursefeelist[i].allowExcessAmount,
                "taxInPaid": this.taxInPaid,
                "taxOnNetFee": this.taxOnNetFee,
                "appSales": this.payloadcoursefeelist[i].appSales,
                "conPayments": this.payloadcoursefeelist[i].conPayments,
                "conPriority": this.payloadcoursefeelist[i].conPriority,
                "deductPriority": this.payloadcoursefeelist[i].deductPriority,
                "paymentModel": this.payloadcoursefeelist[i].paymentModel,
                "deductionModel": this.payloadcoursefeelist[i].deductionModel,
                "concessionModel": this.payloadcoursefeelist[i].concessionModel,
                "displayName": this.payloadcoursefeelist[i].displayName,
                "courseDisplay": this.payloadcoursefeelist[i].courseDisplay,
                "receiptsType": this.payloadcoursefeelist[i].receiptsType,
                "status": true
              }         
              if(this.dialogdata)
                {
                  this.courseFeeDialog(value)
                }
            }
            else{
              for(let k=0;k<this.payloadakashbooks.length;k++)
                {
                  if(this.payloadakashbooks[k].status)
                    {
                  this.addedlist.push(this.payloadakashbooks[k].tranHeadId)
                    }
                }
              this.dialogdata = {
                "orgId":this.orgId,
                "orgSub":this.orgsub,
                "courseFeeHeadId": this.payloadakashbooks[i].courseFeeHeadId,
                "headCode":"AKASH_BOOKS",
                "headAmount": this.payloadakashbooks[i].headAmount,
                "tranHeadId": this.payloadakashbooks[i].tranHeadId,
                "subTransCode": this.payloadakashbooks[i].subTransCode,
                "appFee": this.payloadakashbooks[i].appFee,
                "allowAdditionalAmount": this.payloadakashbooks[i].allowAdditionalAmount,
                "allowExcessAmount": this.payloadakashbooks[i].allowExcessAmount,
                "taxInPaid": this.taxInPaid,
                "taxOnNetFee": this.taxOnNetFee,
                "appSales": this.payloadakashbooks[i].appSales,
                "conPayments": this.payloadakashbooks[i].conPayments,
                "conPriority": this.payloadakashbooks[i].conPriority,
                "deductPriority": this.payloadakashbooks[i].deductPriority,
                "paymentModel": this.payloadakashbooks[i].paymentModel,
                "deductionModel": this.payloadakashbooks[i].deductionModel,
                "concessionModel": this.payloadakashbooks[i].concessionModel,
                "displayName": this.payloadakashbooks[i].displayName,
                "courseDisplay": this.payloadakashbooks[i].courseDisplay,
                "receiptsType": this.payloadakashbooks[i].receiptsType,
                "status": true
              }
              this.akashDialog(value)
              
        }
      }
        else {
          this.dialogdata={
            "orgId":25,
            "orgSub":"BEPL",
            "courseFeeHeadId":0,
            "headCode":this.code,
            "headAmount": 0,
            "tranHeadId": 0,
            "subTransCode": '',
            "appFee":0,
            "allowAdditionalAmount":0,
            "allowExcessAmount":0,
            "taxInPaid":0,
            "taxOnNetFee":0 ,
            "appSales":0,
            "conPayments":0,
            "conPriority":0,
            "deductPriority":0,
            "paymentModel":"Flat",
            "deductionModel": "Flat",
            "concessionModel":"Flat",
            "displayName": '',
            "courseDisplay":'',
            "receiptsType":"BY_PRE_PRINTED_RECEIPT",
            "status":true
          }
          if(value=="FEE")
            {
              
                for(let k=0;k<this.payloadcoursefeelist.length;k++)
                  {
                     if(this.payloadcoursefeelist[k].status)
                      {
                    this.addedlist.push(this.payloadcoursefeelist[k].tranHeadId)
                  }
                  }
              this.courseFeeDialog(value)
            }
            else {
              for(let k=0;k<this.payloadakashbooks.length;k++)
                {
                  if(this.payloadakashbooks[k].status)
                    {
                  this.addedlist.push(this.payloadakashbooks[k].tranHeadId)
                    }
                }
              this.akashDialog(value)
            }
          
        }
        
  }
  verify(item: any) {
    if (item == null) {
      return false;
    }
    else {
      return true;
    }
  }
  promotingcolor() {
  }
  getappsales(value: any) {
    this.appprorityId = value.priorityId
    this.appsalesName = value.priorityName
  }
  getpaymentprority(value: any) {
    this.paymentpriority = value.priorityId
    this.paypriorityname = value.priorityName
  }
  getconcessionpriority(value: any) {
    this.conscessionpriority = value.priorityId
    this.conName = value.priorityName
  }
  getdeductionpriority(value: any) {
    this.deductionpriority = value.priorityId
    this.dedpriority = value.priorityName
  }
  getpaymentmodel(value: any) {
    this.paymentcal = value.paymentModel
    this.paymentdisplay=value.displayName
  }
  getconcessiomodel(value: any) {
    this.concessionmod = value.paymentModel
    this.condisplay=value.displayName
  }
  getdeductionmodel(value: any) {
    this.deductionmod = value.paymentModel
    this.deductdisplay=value.displayName
  }
  getreciot(value: any) {
    this.reiciettype = value.receiptType
    this.recietdisplay=value.displayName
  }
  getAmount() {
    const totalCourseFee = this.data.get('totalCourseFee').value;
    const akashdata = this.myGroup.get('akashdata').value;
    this.previousfee = Number(totalCourseFee) + Number(akashdata);
    this.payload = {
      "courseFeeId": this.coursefeeID,
      "campusTrackId": this.dtservice.campusTrackId,
      "academicId": this.finalacademyyear,
      "batchId": this.finalbatch,
      "orientationType": this.finalorient.toUpperCase(),
      "orgId": this.finalorg,
      "coachingType": this.finalcoachingtype,
      "programId": this.finalprogram,
      "previousFeeAmmount": this.previousfee,
      "concession": Number(this.data.get('maxConcession').value),
      "orgConcession": Number(this.data.get('orgConcession').value),
      "courseStrength": Number(this.data.get('currentStrength').value),
      "registrationFee": Number(this.data.get('registrationFee').value),
      "incentive": this.getboolean(this.data.get('proincentive').value),
      "courseFeeHeadWiseList": this.saveheaddata
    }
  }
  back(){
     this.app.toggleComponents()
  }
  geteditdata() {
    if (this.whethereditOrnot) {
      this.finalacademyyear = this.details.academicId;
      this.finalbatch = this.details.batchId
      this.finalorient = this.details.orientationType;
      this.finalorg = this.details.orgId
      this.finalcoachingtype = this.details.coachingType
      this.finalprogram = this.details.programId
      this.finalpromtingCourseTrack=this.details.promotingCourseTrackId
  
    }
    else {
      this.finalacademyyear = this.academicId
      this.finalbatch = this.batchId
      this.finalorient = this.orientationtype
      this.finalorg = this.orgId
      this.finalcoachingtype = this.coachintype
      this.finalprogram = this.programId
 
    }
  }
  getSum() {
    this.amountsum = 0;
    this.amountsum2=0;
    this.totalsum=0;
    this.length=this.lists.length+this.akashlist.length;
    for (let i = 0; i < this.lists.length; i++) {
      this.amountsum = this.amountsum + Number(this.lists[i].headAmount)
    }
    for (let i = 0; i < this.akashlist.length; i++) {
      this.amountsum2 = this.amountsum2 + Number(this.akashlist[i].headAmount)
    }
    this.totalsum=this.amountsum+this.amountsum2;
  
  }
  verifyAmount() {
    this.getSum()
    this.geteditdata()
    const totalCourseFee = this.data.get('totalCourseFee').value;
    const akashdata = this.myGroup.get('akashdata').value;
    this.previousfee = Number(totalCourseFee) + Number(akashdata);
    if (this.totalsum == this.previousfee) {
      for(let i=0;i<this.payloadcoursefeelist.length;i++)
      {
        this.saveheaddata.push(this.payloadcoursefeelist[i])
      }
      for(let i=0;i<this.akashlist.length;i++)
      {
        this.saveheaddata.push(this.payloadakashbooks[i])
      }
      this.openDialog()
    }
    else {
      const data = 'Enter Heads Correctly '
      this.dialog.open(AlertComponent, {
        width: '800px',
        position: { top: '10px', right: '10px' },
        data: { data }
      });
    }
  }
}